import {
  Answer,
  ChoiceQuestion,
  ChoiceResponse,
  createChoiceAnswer,
  isChoiceResponse,
} from "@cur8/questionnaire";
import { ReactComponent as ArrowSvg } from "assets/arrow-right.svg";
import React, { useCallback } from "react";
import { Typography } from "render/ui/presentation/Typography";
import styles from "./styles.module.sass";

interface ChoiceInputProps<T> {
  question: ChoiceQuestion<T, React.ReactNode>;
  answer?: Answer;
  onAnswer: (answer: Answer<ChoiceResponse>) => void;
}

export function ChoiceInput<T>({
  question,
  answer,
  onAnswer,
}: ChoiceInputProps<T>) {
  let pickedIndex: number;

  if (answer && isChoiceResponse(answer.response)) {
    pickedIndex = answer.response.choiceIndex;
  }

  const handleChoice = useCallback(
    (choiceIndex: number) => {
      const answer = createChoiceAnswer(choiceIndex);
      onAnswer(answer);
    },
    [onAnswer]
  );
  return (
    <fieldset data-hj-suppress className={styles.ChoiceInput}>
      {question.choices.map((choice, choiceIndex) => (
        <label
          className={styles.choice}
          key={choiceIndex}
          data-picked={choiceIndex === pickedIndex}
        >
          <input
            type="radio"
            onClick={() => handleChoice(choiceIndex)}
            id={String(choiceIndex)}
            value={choiceIndex}
          />
          <Typography variant="cta">{choice.statement}</Typography>
          <ArrowSvg aria-hidden={true} />
        </label>
      ))}
    </fieldset>
  );
}
